import { render } from "./QuestionComponent.vue?vue&type=template&id=be5ceb90&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"

import "./QuestionComponent.vue?vue&type=style&index=0&id=be5ceb90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5ceb90"]])

export default __exports__